/**
 * 見た目の制御を行うための関数など
 */

import paramToString from '@/utils/paramToString'
import './style.scss'

export default {
  methods: {
    paramToString,
    /**
     * 登録済みの値が存在するかどうかチェック
     * @param {String} key - name属性値
     * @return Boolean カラムになにかしらの値があればtrue
     */
    hasRegisteredValue(key = '') {
      if (this.registedColumn.hasOwnProperty(key)) {
        return !!String(this.registedColumn[key])
      } else {
        return false
      }
    },
    /**
     * 各セクションで入力フィールドを表示する必要があるかチェック
     * @param { Object } - self, target, entry, authなど ./dataControl.jsで定義してるv-model
     */
    showFieldSection(fields = {}) {
      // 手相
      if (fields.palm) {
        this.updatePalmSendFlg()
        fields.palm.storagePath = this.postParams.storage_path

        return Boolean(
          this.inputParam.image_url_palm_left ||
            this.inputParam.image_url_palm_right ||
            this.inputParam.image_url_palm_left_overall ||
            this.inputParam.image_url_palm_right_overall
        )
      }
      if (this.isEditMode) {
        return Boolean(Object.keys(fields).length)
      }
      return Boolean(
        Object.keys(fields).find(key => !this.hasRegisteredValue(key))
      )
    },
    // 手相の表示項目制御
    updatePalmSendFlg() {
      this.palm.palm.fields.forEach(field => {
        Object.assign(field, {
          sendFlg: Boolean(this.inputParam[field.name])
        })
      })
    },

    // タブクリック時の制御
    handleTabClick(item) {
      if (this.tab.selected === item.name) {
        return
      }

      this.tab.selected = item.name
      switch (item.name) {
        case 'editView':
          this.isEditMode = true
          // this.resetRegistedColumn()
          break
        case 'registedView':
          this.isEditMode = false
          this.setRegistedColumn()
          break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/EntryForm/mixins/viewControl.js